import { useState, useContext, useEffect } from "react"
import { useParams } from "react-router-dom"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { MultiSelect } from "primereact/multiselect"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function MultiOrganizationIdsByLocation({
  field,
  block,
  index,
}) {
  const { idStamp, type } = useParams()
  const isEnterprise = type === "enterprise"

  const [organizationList, setOrganizationList] = useState([])
  const [visible, setVisible] = useState("block")
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_ORGANIZATION = gql`
    query Organization(
      $staff_id: ID!
      $location_id: ID!
      $organization_id: ID!
      $isEnterprise: Boolean!
    ) {
      organizations: getOrganizationsByOrganizationId(
        staff_id: $staff_id
        organization_id: $organization_id
        isEnterprise: $isEnterprise
      ) {
        key: organization_id
        label: organization_name
      }
      organizationsSelected: organizationByLocationId(
        location_id: $location_id
      ) {
        key: organization_id
        label: organization_name
      }
    }
  `
  const { loading } = useQuery(GET_ORGANIZATION, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      location_id: idStamp || "",
      isEnterprise: isEnterprise,
    },
    onCompleted: ({ organizations, organizationsSelected }) => {
      setOrganizationList(organizations)
      formik.setFieldValue(field.field_name, organizationsSelected)
    },
    skip: !userCtx,
  })

  const handleSelectOrganizationIds = ({ e, form }) => {
    if (e.value === null) {
      form.setFieldValue(field.field_name, "")
    } else {
      form.setFieldValue(field.field_name, e.value)
    }
  }

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta, form }) => (
          <>
            <MultiSelect
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={(e) => handleSelectOrganizationIds({ e, form })}
              disabled={isDisabled}
              options={organizationList}
              filter={false}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
